/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolmenu3Inputs */

const en_medialibrarytoolmenu3 = /** @type {(inputs: Medialibrarytoolmenu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const de_medialibrarytoolmenu3 = /** @type {(inputs: Medialibrarytoolmenu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Medialibrarytoolmenu3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolmenu3 = /** @type {((inputs?: Medialibrarytoolmenu3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolmenu3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolmenu3(inputs)
	return de_medialibrarytoolmenu3(inputs)
});
export { medialibrarytoolmenu3 as "mediaLibraryToolMenu" }